import { Box } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { IconShieldCheck } from '@tabler/icons-react';

// Footer privacy band (Landing-Page-Spec section 6): a prominent, weightier
// statement than fine print, with a subtle upward green wash. The legal links
// (Privacy / Terms / contact + copyright) are preserved as a slim sub-line so
// the redesign does not silently drop them.
const PrivacyBand = () => {
  const theme = useTheme();
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundImage: `linear-gradient(180deg, ${alpha(theme.palette.success.main, 0)}, ${alpha(
          theme.palette.success.main,
          0.05,
        )})`,
        px: 3,
        py: '22px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '13px',
        textAlign: 'center',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, maxWidth: 640 }}>
        <Box
          aria-hidden
          sx={{
            flexShrink: 0,
            width: 30,
            height: 30,
            borderRadius: '9px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: alpha(theme.palette.success.main, 0.13),
            color: theme.palette.success.main,
          }}
        >
          <IconShieldCheck size={18} />
        </Box>
        <Box component="p" sx={{ m: 0, fontSize: 15, lineHeight: 1.5, color: theme.palette.text.secondary }}>
          <Box component="span" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
            Your data stays private.
          </Box>{' '}
          Never shared, never sold, never disclosed to third parties absent a valid court order.
        </Box>
      </Box>

      <Box sx={{ fontSize: '0.8rem', color: theme.palette.text.dim }}>
        {'©'} {year} Root Pragmatic LLC{' · '}
        <a href="/privacy" style={{ color: 'inherit', textDecoration: 'underline' }}>
          Privacy
        </a>
        {' · '}
        <a href="/terms" style={{ color: 'inherit', textDecoration: 'underline' }}>
          Terms
        </a>
        {' · '}
        <a href="mailto:info@budgetrecon.com" style={{ color: 'inherit', textDecoration: 'underline' }}>
          info@budgetrecon.com
        </a>
      </Box>
    </Box>
  );
};

export default PrivacyBand;
